var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-avatar',{class:['gpro-avatar', _vm.colorClass],style:(_vm.fontSize
      ? {
          fontSize: typeof _vm.fontSize === 'number' ? _vm.fontSize + 'px' : _vm.fontSize,
        }
      : null),attrs:{"size":_vm.size,"shape":_vm.shape,"src":_vm.photoSrc}},[_vm._v(_vm._s(_vm.initial))])}
var staticRenderFns = []

export { render, staticRenderFns }